import axiosInstance from '../common/axiosInstance'
import { API_ROUTES } from '../common/routes'

export const patchSetHeartChecking = async (payload) => {
  try {
    const res = await axiosInstance.patch(API_ROUTES.Live.SetHeartChecking, payload)
    return res.data
  } catch (error) {
    console.error(error)
    return {}
  }
}
